<script>
	import { replace } from 'svelte-spa-router'

	export let params = {};

	let dash_token = params.t;
	let section = params.s;
	let a1 = params.a1;

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	if (section == 'map') {
		//replace("/map/" + dash_token + "/0/" + a1);

		console.log('resetting from go')
		let zoom = 2; 
		let lo_x = 0; 
		let lo_y = 0;
		setCookie("map_zoom", zoom, 1);
		setCookie("map_lo_x", lo_x, 1);
		setCookie("map_lo_y", lo_y, 1);

		if (a1 != '') {
			replace("/map/2/1/" + a1);
		} else {
			replace("/map/2/1");
		}
	}

	if (section == 'map42') {
		//replace("/map/" + dash_token + "/0/" + a1);

		console.log('resetting from go')
		if (a1 != '') {
			replace("/map42/2/1/" + a1);
		} else {
			replace("/map42/2/1");
		}
	}

</script>
